import React from 'react';
import { Player } from './Player';
export { BackgroundVideo } from './BackgroundVideo';
export const VideoPlayer = ({ ...videoPlayerProps }) => {
    switch (videoPlayerProps.contentType) {
        case 'squareVideo':
            return React.createElement(Player, { ...videoPlayerProps, aspectRatio: "1 / 1" });
        case 'verticalVideo':
            return React.createElement(Player, { ...videoPlayerProps, aspectRatio: "9 / 16" });
        case 'ultraWideVideo':
            return React.createElement(Player, { ...videoPlayerProps, aspectRatio: "21 / 9" });
        case 'wideVideo':
        default:
            return React.createElement(Player, { ...videoPlayerProps, aspectRatio: "16 / 9" });
    }
};
